@import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600;9..144,700&family=Nunito+Sans:ital,wght@0,400;0,600;0,700;1,400&display=swap');

@tailwind base;
@tailwind components;
@tailwind utilities;

:root {
  /* Fondos cálidos (blanco hueso -> maderas) */
  --background-50: 0.985 0.004 85;
  --background-100: 0.966 0.009 82;
  --background-200: 0.936 0.016 80;
  --background-300: 0.892 0.024 78;
  --background-400: 0.83 0.034 76;
  --background-500: 0.77 0.045 74;
  --background-600: 0.68 0.043 72;
  --background-700: 0.56 0.038 70;
  --background-800: 0.44 0.032 68;
  --background-900: 0.33 0.026 66;
  --background-950: 0.23 0.02 64;

  /* Primario: amarillo/dorado del logo Iokus */
  --primary-50: 0.972 0.028 88;
  --primary-100: 0.945 0.06 87;
  --primary-200: 0.905 0.1 85;
  --primary-300: 0.862 0.135 83;
  --primary-400: 0.82 0.155 80;
  --primary-500: 0.775 0.158 78;
  --primary-600: 0.7 0.15 76;
  --primary-700: 0.6 0.138 73;
  --primary-800: 0.5 0.118 70;
  --primary-900: 0.42 0.1 68;
  --primary-950: 0.31 0.078 66;

  /* Acento: magenta del logo Iokus */
  --accent-50: 0.965 0.03 12;
  --accent-100: 0.925 0.06 12;
  --accent-200: 0.865 0.115 12;
  --accent-300: 0.785 0.165 12;
  --accent-400: 0.68 0.21 12;
  --accent-500: 0.585 0.228 12;
  --accent-600: 0.52 0.205 12;
  --accent-700: 0.44 0.178 12;
  --accent-800: 0.36 0.148 12;
  --accent-900: 0.29 0.118 12;
  --accent-950: 0.21 0.085 12;

  /* Secundario: gris cálido / madera del logo Iokus */
  --secondary-50: 0.965 0.005 72;
  --secondary-100: 0.925 0.007 72;
  --secondary-200: 0.865 0.01 70;
  --secondary-300: 0.765 0.013 68;
  --secondary-400: 0.645 0.013 66;
  --secondary-500: 0.525 0.012 64;
  --secondary-600: 0.445 0.012 62;
  --secondary-700: 0.372 0.012 60;
  --secondary-800: 0.3 0.012 58;
  --secondary-900: 0.238 0.011 56;
  --secondary-950: 0.175 0.01 54;

  /* Texto (marrones cálidos) */
  --foreground-50: 0.968 0.007 72;
  --foreground-100: 0.93 0.009 70;
  --foreground-200: 0.862 0.013 68;
  --foreground-300: 0.762 0.016 66;
  --foreground-400: 0.63 0.017 63;
  --foreground-500: 0.51 0.016 60;
  --foreground-600: 0.43 0.015 58;
  --foreground-700: 0.355 0.014 56;
  --foreground-800: 0.285 0.013 54;
  --foreground-900: 0.225 0.012 52;
  --foreground-950: 0.155 0.012 50;

  --font-heading: 'Fraunces', Georgia, 'Times New Roman', serif;
  --font-body: 'Nunito Sans', system-ui, -apple-system, sans-serif;
  --font-label: 'Nunito Sans', system-ui, sans-serif;
}

@layer base {
  html {
    scroll-behavior: smooth;
    -webkit-text-size-adjust: 100%;
  }

  body {
    background-color: oklch(var(--background-50));
    color: oklch(var(--foreground-900));
    font-family: var(--font-body);
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }

  h1, h2, h3, h4 {
    font-family: var(--font-heading);
    color: oklch(var(--foreground-950));
    letter-spacing: -0.01em;
  }

  ::selection {
    background-color: oklch(var(--primary-200));
    color: oklch(var(--foreground-950));
  }
}

/* Aparición suave al hacer scroll (200–300ms) */
.reveal {
  opacity: 0;
  transform: translateY(16px);
  transition: opacity 260ms ease, transform 260ms ease;
  will-change: opacity, transform;
}

.reveal.is-visible {
  opacity: 1;
  transform: none;
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }
  .reveal {
    opacity: 1;
    transform: none;
    transition: none;
  }
}